export enum SapClientTypes {
  SapR3 = 'R3',
  S4Hana = 'S4',
}
